export enum BpeGridSortDirectionEnum {
  NotDefined,
  ASC,
  DESC
}